import React from 'react'
import { Row, Container } from 'react-bootstrap';
import './casestudybody36.css';

import clientimg from '../images/case-study-client36.webp'
import outcome from '../images/outcome36.webp'

import sm1 from '../images/cs36so1u.webp'
import sm2 from '../images/cs36so2u.webp'
import sm3 from '../images/cs36so3u.webp'
import sm4 from '../images/cs36so4u.webp'


const Casestudybody36 = () => {

    return (
        <>
        <section className='casestudybody36-section'  >
          <Container>

            <Row className='w-100 py-md-5 py-4 clintrow'>
                <div className='col-md-4 relative order-1'>
                  <div className='left-box'>
                    <div className='content-box'>
                      <h2>About</h2>
                      {/* <div className="h1"><span className='h1 animate-underline' style={{ paddingBottom: "40px" }}>The Client</span></div> */}
                      <div className="h1">The Client</div>
                      <p className='anima '><span className='only-anima-underline' > **** </span></p>
                      <p>A growth-focused venture capital fund with an AUM of approximately USD 300 Mn, pursuing a private equity secondaries transaction to acquire stakes in portfolio companies of another VC fund</p>
                    </div>
                  </div>
                           
                </div>
                <div className='col-md-8 right-box'>
                    <img src={clientimg} alt="" />
                </div>
            </Row>
       
            <Row className='mt-md-5'>
              <div className='col-md-12'>
                <div className='content-box'>
                  <h2>Situation</h2>
                  {/* <div className="h1"><span className='h1 animate-underline' style={{ paddingBottom: "40px" }}>The Client</span></div> */}
                  <div className="h1">Overview</div>
                  <p className='anima '><span className='only-anima-underline' > **** </span></p>
                  <p>The client required comprehensive financial due diligence on the portfolio companies to assess investment viability, validate financial performance, and structure deal terms. Primary focus on evaluating 4-year historical performance and cash flow dynamics to support acquisition decisions</p>
                </div>
                
              </div>
            </Row>
          </Container>
        </section>
    
        <section className='casestudybody36-section bg-gredient-dark'>
          <Container>
            <Row>
              <div className='col-md-12'>
                  <div className='content-box'>
                    <h2>Approach &</h2>
                    {/* <div className="h1"><span className='h1 animate-underline' style={{ paddingBottom: "40px" }}>The Client</span></div> */}
                    <div className="h1">Methodology</div>
                    <p className='anima '><span className='only-anima-underline' > **** </span></p>
                    {/* <p>The next step was to put together and implement a step-by-step process for conducting the valuation:</p> */}
                    
                    <div className='list-text my-3'>
                        <div className='icon'>
                        <svg width="23" height="23" viewBox="0 0 23 23" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <circle cx="11.5" cy="11.5" r="11" fill="#03A393" stroke="white"/>
                        </svg>
                        </div>
                        <div className='text'>
                          <h4>Data Collection: </h4>
                          <p>Compiled <span style={{color:"#03A393"}}> detailed financial statements for each target portfolio company</span> from sell-side data room following comprehensive Information Request List (IRL) preparation. Extracted audited financials (P&L trends and balance sheets), management accounts, and supporting documentation across multiple reporting periods</p>
                        </div>
                      </div>
    
                    <div className='list-text my-3'>
                        <div className='icon'>
                        <svg width="23" height="23" viewBox="0 0 23 23" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <circle cx="11.5" cy="11.5" r="11" fill="#03A393" stroke="white"/>
                        </svg>
                        </div>
                        <div className='text'>
                          <h4>Financials Consolidation: </h4>
                          <p>Consolidated target company financials into <span style={{color:"#03A393"}}>standardized analytical framework for cross-portfolio comparison</span>. Applied adjustments for one-time items, accounting policy differences, and non-recurring expenses to ensure consistency and comparability across deal evaluation</p>
                        </div>
                      </div>
    
                      <div className='list-text my-3'>
                        <div className='icon'>
                        <svg width="23" height="23" viewBox="0 0 23 23" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <circle cx="11.5" cy="11.5" r="11" fill="#03A393" stroke="white"/>
                        </svg>
                        </div>
                        <div className='text'>
                          <h4>Revenue Quality & Operating Performance:</h4>
                          <p>Validated <span style={{color:"#03A393"}}>revenue recognition processes through customer segmentation analysis</span>, assessed recurring vs. one-time sales patterns, and analyzed unit economics, margin progression, and cost structure efficiency to determine financial runway</p>
                        </div>
                      </div>
    
                      <div className='list-text my-3'>
                        <div className='icon'>
                        <svg width="23" height="23" viewBox="0 0 23 23" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <circle cx="11.5" cy="11.5" r="11" fill="#03A393" stroke="white"/>
                        </svg>
                        </div>

                        <div className='text'>
                          <h4>Industry Benchmarking:</h4>
                          <p>Benchmarked <span style={{color:"#03A393"}}>financial metrics against peer groups</span> using operational KPIs sourced via industry databases and public research</p>
                        </div>
                      </div>

                      <div className='list-text my-3'>
                        <div className='icon'>
                        <svg width="23" height="23" viewBox="0 0 23 23" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <circle cx="11.5" cy="11.5" r="11" fill="#03A393" stroke="white"/>
                        </svg>
                        </div>

                        <div className='text'>
                          <h4>Risk Identification & Red Flag Analysis: </h4>
                          <p>Highlighted <span style={{color:"#03A393"}}>potential financial risks</span> including high customer concentration, seasonal fluctuations, operational inefficiencies, and accounting irregularities requiring management attention</p>
                        </div>
                      </div>                 

                      <div className='list-text last-child my-3'>
                        <div className='icon'>
                        <svg width="23" height="23" viewBox="0 0 23 23" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <circle cx="11.5" cy="11.5" r="11" fill="#03A393" stroke="white"/>
                        </svg>
                        </div>

                        <div className='text'>
                          <h4>Standardized Reporting:</h4>
                          <p>Consolidated findings into <span style={{color:"#03A393"}}>structured Financial Due Diligence reports</span> with executive summaries, detailed financial analysis and key ratio assessments for investment decision support</p>
                        </div>
                      </div> 

                                        
                      <h3 className='mt-5'>Sample Output</h3>
                      <div className='sample-output mt-3'>
                        <img src={sm1} alt=''/>
                        <img src={sm2} alt=''/>
                        <img src={sm3} alt=''/>
                        <img src={sm4} alt=''/>
                      </div>
                  </div>
                  
                </div>
            </Row>
          </Container>
        </section>

    
        <section className='casestudybody36-section outcome'  >
          <Container>
            <Row className='w-100 pb-5 clintrow '>
                <div className='col-md-4 relative order-1'>
                  <div className='left-box'>
                    <div className='content-box'>
                      <div className="h1">Outcome</div>
                      <p className='anima '><span className='only-anima-underline' > **** </span></p>
                      <p>Conducted structured financial review across shortlisted companies, identifying key risks and financial red flags tied to revenue quality, cost structure inefficiencies, and working capital performance. The client was able to assess business model resilience and financial runway across target assets, directly informing pricing discussions</p>  
                    </div>
                  </div>
                           
                </div>
                <div className='col-md-8 right-box'>
                    <img src={outcome} alt="" />
                </div>
            </Row>
       
          </Container>
        </section>
    
        </>  
      )
    }

export default Casestudybody36
